/* TOA persistent category switch guard */
(function () {
  "use strict";

  if (window.__toaCategorySwitchGuard) return;
  window.__toaCategorySwitchGuard = true;

  var toggleSelector = ".toa-category-expand";
  var nodeSelector = ".toa-category-node";
  var rowSelector = ".toa-category-row";
  var childrenSelector = ".toa-category-children";
  var syncScheduled = false;

  function checkboxIn(element) {
    return element ? element.querySelector('input[type="checkbox"]') : null;
  }

  function childCheckboxes(node) {
    var children = node ? node.querySelector(childrenSelector) : null;
    return children ? children.querySelectorAll('input[type="checkbox"]') : [];
  }

  function syncNode(node) {
    var mainInput = checkboxIn(node.querySelector(rowSelector));
    var toggle = node.querySelector(toggleSelector);
    var fineInputs = childCheckboxes(node);
    if (!mainInput || !toggle || !mainInput.checked || !fineInputs.length) return;

    node.classList.add("is-open");
    toggle.textContent = "\u2212";
    toggle.setAttribute("aria-expanded", "true");
    toggle.setAttribute("aria-busy", "false");

    var label = (toggle.getAttribute("aria-label") || "")
      .replace(/^Unterkategorien (?:\u00f6ffnen|schlie\u00dfen):\s*/i, "");
    if (label) toggle.setAttribute("aria-label", "Unterkategorien schlie\u00dfen: " + label);
  }

  function syncAll() {
    syncScheduled = false;
    document.querySelectorAll(nodeSelector).forEach(syncNode);
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    window.requestAnimationFrame(syncAll);
  }

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest(toggleSelector);
    if (!toggle) return;

    var node = toggle.closest(nodeSelector);
    if (!node || childCheckboxes(node).length) return;

    var mainInput = checkboxIn(node.querySelector(rowSelector));
    if (!mainInput || mainInput.checked || mainInput.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    toggle.setAttribute("aria-busy", "true");
    mainInput.click();
    scheduleSync();
  }, true);

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
}());
